import { IconAdd } from '@consta/icons/IconAdd'
import { Button } from '@consta/uikit/Button'
import { Text } from '@consta/uikit/Text'
import { CreateProjectModal } from '@core/components'
import type { FC } from 'react'
import { useState } from 'react'

import css from './MainHeader.css'

export const MainHeader: FC = () => {
  const [isDlgVisible, setIsDlgVisible] = useState(false)
  const openDlg = () => {
    setIsDlgVisible(true)
  }
  const closeDlg = () => {
    setIsDlgVisible(false)
  }

  return (
    <div className={css.mainHeader}>
      <Text size="3xl" weight="bold" view="primary">
        Проекты
      </Text>
      <Button
        label="Новый проект"
        size="s"
        iconLeft={IconAdd}
        data-analytics-id="project_new_click"
        onClick={openDlg}
      />
      {!!isDlgVisible && <CreateProjectModal isModalOpen={isDlgVisible} closeModal={closeDlg} />}
    </div>
  )
}
